(() => {
  const language = (document.documentElement.lang || window.Shopify?.locale || 'en')
    .toLowerCase()
    .split('-')[0];

  const translations = {
    de: {
      progress: (amount) => `Nur noch ${amount} bis zum kostenlosen Versand`,
      label: 'Kostenloser Versand'
    },
    nl: {
      progress: (amount) => `Nog ${amount} tot gratis verzending`,
      label: 'Gratis verzending'
    },
    es: {
      progress: (amount) => `Te faltan ${amount} para conseguir el envío gratuito`,
      label: 'Envío gratuito'
    },
    fr: {
      progress: (amount) => `Plus que ${amount} pour bénéficier de la livraison gratuite`,
      label: 'Livraison gratuite'
    },
    it: {
      progress: (amount) => `Ti mancano ${amount} per ottenere la spedizione gratuita`,
      label: 'Spedizione gratuita'
    },
    pt: {
      progress: (amount) => `Faltam ${amount} para obter portes grátis`,
      label: 'Portes grátis'
    },
    fi: {
      progress: (amount) => `Vielä ${amount} ilmaiseen toimitukseen`,
      label: 'Ilmainen toimitus'
    },
    bg: {
      progress: (amount) => `Остават ви ${amount} до безплатна доставка`,
      label: 'Безплатна доставка'
    }
  };

  const copy = translations[language];
  if (!copy) return;

  const drawerSelector = '#aov-cart-drawer';
  const progressSelector = '.AOV-CartDrawer-RewardBar__Title';
  const labelSelector = '.AOV-CartDrawer-RewardBar__ProgressBar__GoalTitle';
  const progressPattern =
    /^(?:you are|you're)\s+(.+?)\s+away from(?:\s+getting)?\s+free shipping[.!]?$/i;

  const replaceText = (element, replacement) => {
    const raw = element.textContent || '';
    const trimmed = raw.trim();
    if (!trimmed || trimmed === replacement) return;
    element.textContent = raw.replace(trimmed, replacement);
  };

  const translateDrawer = () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    drawer.querySelectorAll(progressSelector).forEach((element) => {
      const match = (element.textContent || '').trim().match(progressPattern);
      if (match) replaceText(element, copy.progress(match[1]));
    });

    drawer.querySelectorAll(labelSelector).forEach((element) => {
      if (/^free shipping[.!]?$/i.test((element.textContent || '').trim())) {
        replaceText(element, copy.label);
      }
    });
  };

  const start = () => {
    translateDrawer();

    new MutationObserver(translateDrawer).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
